import CallLogPanel from './CallLogPanel';

export * from './CallLogPanel.interface';
export * from './CallLog.interface';

export default CallLogPanel;
